import { LayoutContainer, Picture } from '@petsmart-ui/sparky';
import cn from 'classnames';
import Link from 'next/link';

import { ContentfulClick } from '@libs/analytics';

import { HeaderCtaTracker } from '../../../utils/HeaderCtaTracker';
import { getImageProps } from '../../../utils/propsImagesItems';
import { Text } from '../../Text';
import type { CampaignCarsUpProps } from '../types';
import { colorMap } from '../utils';
import './2up.scss';

export function CampaignCards2up({
    header,
    body,
    cards,
    textLink,
    textLinkColor,
    textColor,
    backgroundFill,
    cardsTextColor,
}: CampaignCarsUpProps) {
    return (
        <LayoutContainer className="campaign-cards-2up">
            <div className="campaign-cards-2up__content" style={{ background: backgroundFill }}>
                <div className="campaign-cards-2up__header">
                    <Text color={textColor} as="h2">
                        {header}
                    </Text>

                    <Text align="center" color={textColor}>
                        {body}
                    </Text>

                    {textLink && (
                        <HeaderCtaTracker
                            textLink={textLink}
                            linkTextColor={textLinkColor}
                            header={header ?? ''}
                            promoVariant="campaign cards up - 2up"
                            promoType="campaign-cards-2up__card"
                        />
                    )}
                </div>

                <div className="campaign-cards-2up__cards">
                    {cards.slice(0, 2).map((c, index) => {
                        const cm = colorMap[cardsTextColor];
                        const linkUrl = c?.link?.webUrl || textLink?.link?.webUrl || '';
                        const Component = linkUrl ? Link : 'div';

                        return (
                            <ContentfulClick
                                component={Component}
                                key={c.sysId}
                                href={linkUrl}
                                className="campaign-cards-2up__card"
                                eventData={{
                                    position: index + 1,
                                    linkText: cn(c.header, c.body),
                                    linkUrl,
                                    promoTitle: header ?? '',
                                    promoVariant: 'campaign cards up - 2up',
                                    promoDesc: c.internalTitle,
                                    promoType: 'campaign-cards-2up__card',
                                }}
                                prefetch={false} // https://petsmart.atlassian.net/browse/HCP-594
                            >
                                <div className="campaign-cards-2up__card-body" style={{ background: c.backgroundFill }}>
                                    <Picture {...getImageProps(c.image)} />
                                    <div className="campaign-cards-2up__card-clip">
                                        <Text as="h2" color={cm?.headingColor}>
                                            {c.header}
                                        </Text>
                                    </div>
                                </div>

                                <div className="campaign-cards-2up__card-content">
                                    <Text color={cm?.textColor} className="campaign-cards-2up__card-text">
                                        {c.body}
                                    </Text>
                                    <Text color={cm?.textColor} className="campaign-cards-2up__card-terms">
                                        {c.terms}
                                    </Text>
                                </div>
                            </ContentfulClick>
                        );
                    })}
                </div>
            </div>
        </LayoutContainer>
    );
}
